import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';

import { FormularAData, FormularAPersonData } from './formular-a.model';

interface FormularARawValue {
  contractPartner: {
    companyName: string;
    streetAndNumber: string;
    postalCode: string;
    city: string;
    country: string;
  };
  persons: FormularAPersonData[];
}

export function createFormularAForm(formBuilder: FormBuilder): FormGroup {
  return formBuilder.group({
    contractPartner: formBuilder.group({
      companyName: ['', Validators.required],
      streetAndNumber: ['', Validators.required],
      postalCode: ['', Validators.required],
      city: ['', Validators.required],
      country: ['Schweiz', Validators.required]
    }),
    persons: formBuilder.array([
      createPersonFormGroup(formBuilder)
    ], Validators.required)
  });
}

export function createPersonFormGroup(formBuilder: FormBuilder): FormGroup {
  return formBuilder.group({
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    birthDate: [''],
    streetAndNumber: ['', Validators.required],
    postalCode: ['', Validators.required],
    city: ['', Validators.required],
    country: ['Schweiz', Validators.required],
    nationality: ['']
  });
}

export function getPersonsFormArray(form: FormGroup): FormArray<FormGroup> {
  return form.get('persons') as FormArray<FormGroup>;
}

export function mapFormularAFormToData(form: FormGroup): FormularAData {
  const rawValue = form.getRawValue() as FormularARawValue;
  const persons = rawValue.persons.map(normalizePerson);
  const filledPersons = persons.filter((person) => !isFormularAPersonEmpty(person));

  return {
    contractPartner: {
      companyName: normalize(rawValue.contractPartner.companyName),
      streetAndNumber: normalize(rawValue.contractPartner.streetAndNumber),
      postalCode: normalize(rawValue.contractPartner.postalCode),
      city: normalize(rawValue.contractPartner.city),
      country: normalize(rawValue.contractPartner.country)
    },
    persons: filledPersons.length > 0 ? filledPersons : [normalizePerson(rawValue.persons[0])]
  };
}

export function isFormularAPersonEmpty(person: Partial<FormularAPersonData> | null | undefined): boolean {
  if (!person) {
    return true;
  }

  const country = normalize(person.country);
  return !hasText(person.firstName)
    && !hasText(person.lastName)
    && !hasText(person.birthDate)
    && !hasText(person.streetAndNumber)
    && !hasText(person.postalCode)
    && !hasText(person.city)
    && !hasText(person.nationality)
    && (country === '' || country === 'Schweiz');
}

function normalizePerson(person: Partial<FormularAPersonData> | null | undefined): FormularAPersonData {
  return {
    firstName: normalize(person?.firstName),
    lastName: normalize(person?.lastName),
    birthDate: normalize(person?.birthDate),
    streetAndNumber: normalize(person?.streetAndNumber),
    postalCode: normalize(person?.postalCode),
    city: normalize(person?.city),
    country: normalize(person?.country),
    nationality: normalize(person?.nationality)
  };
}

function hasText(value: string | null | undefined): boolean {
  return normalize(value) !== '';
}

function normalize(value: string | null | undefined): string {
  return (value ?? '').trim();
}
